export interface IconThumbnail {
    iconName: string;
    iconDescription: string;
    iconWeight: string;
    filled: boolean;
    key?: string;
}
